module.exports = __webpack_public_path__ + "static/media/icono_valores.2f64c744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_valores.png
// module id = 811
// module chunks = 0